import { TagsDisplay } from "components/TagsDisplay";
import { WasteTagsColumnHeader } from "components/WasteTagsColumnHeader";
import { OmnisearchGridColDef } from "hooks/useOmnisearchDatagrid";

import { lineItemDisplayTags } from "./lineItemDisplayTags";

type TaggedLineRow = {
  tags: { id: string; name: string }[];
  wasteStreamTags: { id: string; name: string }[];
};

/**
 * The line-item grids' Tags column: the line's own tags plus its stream's,
 * with the waste tag filter (match mode and untagged only).
 */
export function lineItemTagsColumn<Row extends TaggedLineRow>(): OmnisearchGridColDef<Row> {
  return {
    field: "tags",
    headerName: "Tags",
    filterKeyType: "wasteTags",
    renderHeader: () => <WasteTagsColumnHeader />,
    flex: 1,
    minWidth: 120,
    renderCell: ({ row }) => <TagsDisplay tags={lineItemDisplayTags(row)} />,
  };
}
